/* global $ u */
import { Get } from 'common'

let questionClassData
let _model

async function initQuesitionTypes () {
  let data = await Get('/cpu-supplymgr/question/questionTypes')
  if (data.status) {
    questionClassData = []
    for (let r of data.data.result) {
      let questionClass = {}
      questionClass.value = r.id
      questionClass.name = r.name
      questionClassData.push(questionClass)
    }
  }
}

async function init (refer) {
  await initQuesitionTypes()
  let vm = {
    code: _model.ref('code'),
    description: _model.ref('description'),
    answer: _model.ref('answer'),
    model: _model,
    questionClassData: questionClassData
  }
  let app = u.createApp()
  app.init(vm, $('#helpQuestion')[0])
}

let template = require('./index.html')
export default function (model) {
  _model = model.datatable
  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/question/index.js